import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './config.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./config.service";
export class AprobacionMasivaService {
    constructor(http, configService) {
        this.http = http;
        this.configService = configService;
        this.jsonContent = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': sessionStorage.getItem('batoken'),
                'User': sessionStorage.getItem('userid')
            })
        };
        this.headers = new HttpHeaders();
    }
    //Llena Filtros
    //Busca los años de las capacitaciones
    getAnnio() {
        let userid = sessionStorage.getItem('userid');
        //Busca los años de las capacitaciones
        return this.http.get(`${this.configService.API_URL}/capacitaciones/find-annio`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
    getAnnioPlanes() {
        return this.http.get(`${this.configService.API_URL}/capacitaciones/find-annio-planes`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
    //Busca las empresas por año
    getEmpresa(annio, userid, rolid) {
        return this.http.get(`${this.configService.API_URL}/capacitaciones/find-empresa?annio=${annio}&userid=${userid}&rolid=${rolid}`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
    //Busca los planes de capacitación
    getPlanCapacitacion(annio, empresa, estado, userid, rolid) {
        return this.http.get(`${this.configService.API_URL}/capacitaciones/find-plan?annio=${annio}&empresa=${empresa}&estado=${estado}&userid=${userid}&rolid=${rolid}`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
    //Busca las capacitaciones Contratista
    getListaCapacitacionesContratista(anio, estado, empresa, tipoCapacitacion) {
        return this.http.get(`${this.configService.API_URL}/capacitaciones/find-capacitaciones-contratista?annio=${anio}&estado=${estado}&empresa=${empresa}&tipoCapacitacion=${tipoCapacitacion}`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
    //Busca las capacitaciones Contratista
    buscarKpiCumplimiento(idPlan) {
        return this.http.get(`${this.configService.API_URL}/capacitaciones/revision-kpi?idPlanCapacitacion=${idPlan}`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
    //Busca las capacitaciones Contratista
    getListaCapacitacionesAdmin(anio, estado, empresa, idPlan, tipoCapacitacion) {
        return this.http.get(`${this.configService.API_URL}/capacitaciones/find-capacitaciones-admin?annio=${anio}&empresa=${empresa}&estado=${estado}&plan=${idPlan}&tipoCapacitacion=${tipoCapacitacion}`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
    getArchivosAdjuntos(capacitacion) {
        return this.http.get(`${this.configService.API_URL}/capacitaciones/find-adjuntos?capacitacion=${capacitacion}`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
    getDownloadFile(capacitacionId, adjunto) {
        return this.http.get(`${this.configService.API_URL}/capacitaciones/download?idCapacitacion=${capacitacionId}&adjunto=${adjunto}`, {
            responseType: 'blob'
        });
    }
    //Actualizacion Estado
    cambioEstadoPlan(plan, accion, observacion, userId) {
        let cap = new Map();
        cap.set("planCapacitacion", plan);
        cap.set("accion", accion);
        cap.set("observacion", observacion);
        cap.set("userId", userId);
        let obj = Array.from(cap).reduce((obj, [key, value]) => Object.assign(obj, { [key]: value }), {});
        let capacitaciones = JSON.stringify(obj);
        return this.http
            .post(`${this.configService.API_URL}/capacitaciones/cambio-estado-plan`, capacitaciones, Object.assign({}, this.jsonContent, { responseType: "text" }))
            .toPromise();
    }
    //Actualizacion Estado
    cancelacionCapacitacion(idCapacitacion, observacion, userId) {
        let cap = new Map();
        cap.set("idCapacitacion", idCapacitacion);
        cap.set("observacion", observacion);
        cap.set("userId", userId);
        let obj = Array.from(cap).reduce((obj, [key, value]) => Object.assign(obj, { [key]: value }), {});
        let capacitaciones = JSON.stringify(obj);
        return this.http
            .post(`${this.configService.API_URL}/capacitaciones/cancelacion-capacitacion`, capacitaciones, Object.assign({}, this.jsonContent, { responseType: "text" }))
            .toPromise();
    }
    updateCapacitacion(capacitacionId, horaCapacitacion, fechaRealizacion, workers, fecha) {
        const body = JSON.stringify({ capacitacionId, horaCapacitacion, fechaRealizacion, workers, fecha });
        return this.http.post(`${this.configService.API_URL}/capacitaciones/update-capacitacion`, body, Object.assign({}, this.jsonContent, { responseType: 'text' })).toPromise();
    }
}
AprobacionMasivaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AprobacionMasivaService_Factory() { return new AprobacionMasivaService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: AprobacionMasivaService, providedIn: "root" });
